import styled from 'styled-components';
import { rgba } from 'polished';
import { primary, neutral, white } from '../../../../style/colors';
import { MOBILE_BREAKPOINT, flexCenter, baseButton } from '../Header.style';

export const LogoSection = styled.div`
  ${flexCenter}
  gap: 16px;
  cursor: pointer;
  transition: transform 0.2s ease;

  &:hover { transform: translateY(-1px); }

  @media (max-width: ${MOBILE_BREAKPOINT}) { gap: 10px; }
`;

export const LogoBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: ${neutral[800]};
  padding: 10px 20px;
  border-radius: 8px;
  min-width: 140px;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    padding: 8px 12px;
    min-width: 100px;
  }
`;

export const LogoBrand = styled.div`
  font-family: 'Times New Roman', Times, serif;
  font-size: 22px;
  color: ${white};
  letter-spacing: 6px;
  text-transform: uppercase;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    font-size: 16px;
    letter-spacing: 4px;
  }
`;

export const LogoCountry = styled.div`
  font-family: 'Times New Roman', Times, serif;
  font-size: 11px;
  color: ${rgba(white, 0.5)};
  letter-spacing: 4px;
  text-transform: uppercase;
  margin-top: 2px;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    font-size: 9px;
    letter-spacing: 2px;
  }
`;

export const LogoTextWrapper = styled.div`
  @media (max-width: ${MOBILE_BREAKPOINT}) { display: none; }
`;

export const LogoText = styled.h1`
  font-size: 28px;
  font-weight: 700;
  color: ${neutral[900]};
  margin: 0;
  letter-spacing: 0.5px;
  
  span { color: ${primary[500]}; }
`;

export const Subtitle = styled.div`
  font-size: 10px;
  color: ${neutral[500]};
  text-transform: uppercase;
  letter-spacing: 1.5px;
  font-weight: 600;
  margin-top: 2px;
`;

export const BackButton = styled.button`
  ${baseButton}
  ${flexCenter}
  gap: 8px;
  color: ${neutral[700]};
  font-size: 14px;
  font-weight: 500;
  padding: 8px 16px;
  border-radius: 8px;

  &:hover {
    background: ${neutral[100]};
    color: ${neutral[900]};
  }

  i { font-size: 18px; }
`;
